import React from 'react'
import PropTypes from 'prop-types'

import { compose } from 'recompose'

import { Menu } from 'semantic-ui-react'

import Enhancer from './TopbarEnhancer'

import Permissions from 'Components/Permissions'

import { THEME_COLOR } from 'Global/constants'

const Topbar = props => {
  const { showChangelogModal, showFeedbackModal, showMyAccountModal, showSettingsModal, signOut, user } = props

  return (
    <div>
      <Menu color={THEME_COLOR} fixed="top" inverted>
        <Menu.Menu position="right">
          <Permissions
            permissions="modules.changelog"
            render={() => <Menu.Item icon="fork" name="Changelog" onClick={showChangelogModal} />}
          />

          <Permissions
            permissions="modules.feedback"
            render={() => <Menu.Item icon="talk" name="Feedback" onClick={showFeedbackModal} />}
          />

          <Menu.Item icon="user" name={`${user.firstName} ${user.lastName}`} onClick={showMyAccountModal} />

          <Permissions
            permissions="modules.settings"
            render={() => <Menu.Item icon="settings" name="Settings" onClick={showSettingsModal} />}
          />

          <Menu.Item icon="log out" name="Sign Out" onClick={signOut} />
        </Menu.Menu>
      </Menu>
    </div>
  )
}

Topbar.propTypes = {
  showChangelogModal: PropTypes.func.isRequired,
  showFeedbackModal: PropTypes.func.isRequired,
  showMyAccountModal: PropTypes.func.isRequired,
  showSettingsModal: PropTypes.func.isRequired,
  signOut: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
}

const composed = compose(Enhancer)

export default composed(Topbar)
